export const parseNumberField = (digits: string): number | null => {
    const parsed = parseInt(digits, 10)
    return Number.isNaN(parsed) || parsed < 1 ? null : parsed
}
